
import Uploader from '@/components/Uploader';

export default {
  props: {
    value: {
      type: String
    },
    prop: {
      type: String
    },
    psdSuccess: {
      type: Boolean || null
    },
    psdMessage: {
      type: Array
    }
  },
  components: {
    Uploader: Uploader
  },
  watch: {
    psdSuccess: function psdSuccess(val) {
      this.psd_success = val;
    },
    psdMessage: function psdMessage(val) {
      var _this = this;

      var msg = void 0;
      if (val && val.length > 0) {
        msg = val.map(function (item) {
          var json = void 0;
          try {
            json = JSON.parse(item);
          } catch (e) {
            return item;
          }
          if (json.data) {
            return _this.$t('playTurbo.commonTemplate.creativeInfo.form.psd2uiErr.' + json.i18n, json.data);
          }
          return _this.$t('playTurbo.commonTemplate.creativeInfo.form.psd2uiErr.' + json.i18n);
        });
      } else {
        msg = '';
      }
      this.psd_message = msg;
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      fileName: '',
      file_list: [],
      progress: 0,
      isUploading: false,
      uploadConfig: {
        drag: true,
        multiple: false,
        showFileList: false,
        fileList: this.file_list,
        onSuccess: function onSuccess(res) {
          _this2.isUploading = false;
          if (res.code === 1) {
            _this2.errorFormText = res.msg;
          } else {
            _this2.errorFormText = '';
            _this2.$emit('input', res.data.file_path);
          }
        },
        beforeUpload: function beforeUpload(file) {
          if (!/^[0-9a-zA-Z_.]+$/.test(file.name)) {
            _this2.errorFormText = _this2.$t('playTurbo.commonTemplate.creativeInfo.form.psd.psdErrorName');
            _this2.fileName = '';
            _this2.$emit('input', '');
            return false;
          }
          _this2.psd_success = null;
          _this2.psd_message = [];
          _this2.errorFormText = '';
          _this2.$emit('input', '');
          _this2.$emit('updatePsdSuccess', null);
        },
        onChange: function onChange(file, fileList) {
          _this2.$emit('updatePsdSuccess', null);
          if (fileList.length > 1) {
            fileList.splice(0, 1);
          }
          _this2.fileName = file.name;
        },
        onProgress: function onProgress(event, file, fileList) {
          _this2.progress = Math.floor(event.percent);
          _this2.isUploading = true;
        },
        accept: '.zip, .psd'
      },
      psd_success: null,
      psd_message: [],
      errorFormText: ''
    };
  },

  methods: {
    clearPsd: function clearPsd() {
      this.$refs.uploader.clearFiles();
      this.$emit('input', '');
      this.fileName = null;
      this.psd_success = null;
      this.psd_message = [];
      this.errorFormText = '';
    },
    updateErrorForm: function updateErrorForm(errorType) {
      switch (errorType) {
        case 'empty':
          this.errorFormText = this.$t('playTurbo.commonTemplate.creativeInfo.form.psd.emptyError');
          break;
        case 'error':
          this.errorFormText = this.$t('playTurbo.commonTemplate.creativeInfo.form.psd.psdError');
          break;
        default:
          break;
      }
    }
  }
};